const state = {
	user: {
		id: '',
		name: '',
		isLeader: false,
	},
	game: {
		id: '',
		number: null,
		name: 'whaddup',
		playerIds: [],
	}
};

export default state;
